import React from 'react';
import './ScrollingBanner.css'; // Import the CSS for styling

const ScrollingBanner = () => {
    return (
        <div className="scrolling-banner">
            <p>🎉 Holiday Sale! 🎉 Get up to 30% off on various perfumes! Shop now and enjoy the festive fragrances! 🎁</p>
        </div>
    );
};

export default ScrollingBanner;
